<template>
	<button
		v-if="useAvatar !== 0"
		class="conversation-avatar btn action"
		:title="conversationId"
	>
		<canvas
			v-if="useAvatar === 1 || useAvatar === 2"
			class="avatar-canvas"
			ref="avatarCanvas"
			width="48"
			height="48"
		></canvas>
		<div
			v-else-if="useAvatar === 3"
			class="avatar-html"
			v-html="avatarHTML"
		></div>
	</button>
</template>

<script>
import jdenticon from 'jdenticon';

export default {
	props: ['providerName', 'conversationId'],
	data() {
		return {
			useAvatar: 0,
			avatarHTML: null
		};
	},
	mounted() {
		let gUA = this.$store.getters[
			'ConversationProviders/provider_' +
				this.providerName +
				'/getConversationAvatar'
		];
		if (gUA) {
			gUA = gUA(this.conversationId);
			if (gUA === 1) {
				this.useAvatar = 1;

				this.$nextTick(function() {
					let ctx = this.$refs.avatarCanvas.getContext('2d');
					jdenticon.drawIcon(ctx, this.conversationId, 48);
				});
			} else if (
				typeof gUA === 'object' &&
				gUA.hasOwnProperty('length')
			) {
				if (gUA[0] === 2) {
					this.useAvatar = 2;

					this.$nextTick(function() {
						let ctx = this.$refs.avatarCanvas.getContext('2d');
						ctx.drawImage(gUA[1], 48, 48);
					});
				} else if (gUA[0] === 3) {
					this.useAvatar = 3;

					this.$nextTick(function() {
						this.avatarHTML = gUA[1];
					});
				}
			}
		}
	}
};
</script>
